<script lang="ts">
export default {
    name: 'LayoutParentView'
};
</script>

<template>
    <div></div>
</template>
